import axios from "axios";


/**
 * A simple middleware service that hooks itself in your axios instance
 */
export default class Api {
	constructor() {}

	token = ""; //localStorage.getItem("token");//if use token
	_url = "indexLegado.php";
	_urlTest = "https://test-consulta-default-rtdb.firebaseio.com/avaliacoes.json";

	post(url, dados) {

		return axios
			.post(
				process.env.VUE_APP_ROOT_API + url,

				Object.assign({}, dados), {
					headers: {
						"Api-Token": this.token,
						'Access-Control-Allow-Headers': 'X-Requested-With,content-type,authorization',
						'Access-Control-Allow-Credentials': true,
					}
				}
			)
			.then(response => {
				if (response.data.erro) {
					Object.noty.error(response.data.msg, {
						timeout: 10000
					});
					return false;
				}


				return response.data;
			})
			.catch(error => {
				return error.response;
				// this.redirectError(error.response.status);
			});
	}

	get(url) {

		return axios
			.get(process.env.VUE_APP_ROOT_API + url, {
				headers: {
					"Api-Token": this.token
				}
			})
			.then(response => {
				if (response.data) {
					return response.data;
				}

				return [];
			});
	}

	getEconet(url) {

		return axios
			.get(url, {
				headers: {
					"Api-Token": this.token
				}
			})
			.then(response => {
				if (response.data) {
					return response.data;
				}

				return [];
			});
	}

	getUrlCompleta(url) {

		return axios.get(url).then(response => {

			return response.data;
		});
	}

	file(url, dados) {
		return axios
			.post(process.env.VUE_APP_ROOT_API + url, dados, {
				headers: {
					"Content-Type": "multipart/form-data",
					"Api-Token": this.token
				}
			})
			.then(response => {
				return response.data;
			});
	}

	impressao(url, dados) {
		let token = this.getToken();
		return axios({
			url: process.env.VUE_APP_ROOT_API + url,
			method: "POST",
			data: dados,
			headers: {
				Accept: "application/pdf",
				"Api-Token": this.token
			},
			responseType: "blob"
		}).then(response => {
			return response;
		});
	}

	redirectError(statusCode) {
		switch (parseInt(statusCode)) {
			case 401:
				window.location = "/erro/401";
				break;
			case 404:
			default:
				window.location = "/erro/404";
				break;
		}
	}



	requisicao = axios.interceptors.response.use(
		function(response) {
			return response;
		},
		function(error) {
			if (
				window.location.pathname != "/erro/401" &&
				window.location.pathname != "/erro/404" &&
				window.location.pathname.indexOf("/validar") === -1
			) {
				switch (parseInt(error.response.status)) {
					case 401:
						if (
							error.response.data.response == "token_empty" ||
							error.response.data.response == "token_invalid"
						) {
							localStorage.removeItem("token");
							localStorage.removeItem("nome_usuario");
							localStorage.removeItem("HASH_USER");
							window.location = "/";
						} else if (
							error.response.data.response == "token_expired"
						) {
							if (localStorage.getItem("HASH_USER")) {
								new Api()
									.getUrlCompleta(
										"https://www.econeteditora.com.br/acesso_spt_login.php?id=" +
										localStorage.getItem("HASH_USER")
									)
									.then(response => {
										if (response.blLogado) {
											//refresh token

											new Api()
												.get(
													"../../api/ValidarLogin/" +
													localStorage.getItem(
														"HASH_USER"
													)
												)
												.then(response => {
													let token =
														response.response.token;
													let nome_usuario =
														response.response.nome;
													localStorage.setItem(
														"token",
														token
													);
													localStorage.setItem(
														"nome_usuario",
														nome_usuario
													);
													error.config.headers[
														"Api-Token"
													] = token;
													return axios.request(
														error.config
													);
												});
											/*
                                                .catch(error => {
                                                
                                                    debugger;

                                                    window.location = "/";
												});
											*/
										} else {
											localStorage.removeItem("token");
											localStorage.removeItem(
												"nome_usuario"
											);
											localStorage.removeItem(
												"HASH_USER"
											);
											window.location = "/";
										}
									});
							} else {
								localStorage.removeItem("token");
								localStorage.removeItem("nome_usuario");
								localStorage.removeItem("HASH_USER");
								window.location = "/";
							}
						}
						break;
					case 404:
						Object.noty.error(
							"Erro ao acessar a API, entre em contato com o suporte.", {
								timeout: 10000
							}
						);
						break;
					case 408:
						Object.noty.error(
							"Erro ao acessar a API, entre em contato com o suporte.", {
								timeout: 10000
							}
						);
						break;
					case 500:
						Object.noty.error(
							"Erro ao acessar a API, entre em contato com o suporte.", {
								timeout: 10000
							}
						);
						break;
					default:
						return Promise.reject(error);
				}
			}
		}
	);

	/* 
	 * Baseado em :
	 * http://www.econeteditora.com.br/consultoria/funcoes.js?1616701471
	 */


	/* 
	* Salvar avaliação
	* O modelo atual utilizando jquery
    *
    function salvarAvaliacaoAjax(obj) {
	    var nota = $(obj).val();
	    var idDiv = $(obj).closest('div').attr('id');
	    var arrDiv = idDiv.split('_');
	    $.ajax({
	        url: 'indexLegado.php',
	        data: {
	            acao: 'inserir_avaliacao',
	            id: arrDiv[3],
	            nota: nota,
	            versao: arrDiv[2]
	        },
	        success: function(e) {
	            $("#" + idDiv).html(e);
	            $('#alertaAvaliacoes').hide();
	        }
	    })
	} */

	salvarAvaliacao(nota) {
		//	let token = this.getToken();
		let urlCompleta = process.env.VUE_APP_ROOT_API + this._url

		return axios({
			url: urlCompleta + "?acao=inserir_avaliacao&id=" + nota.id + "&nota=" + nota.nota + "&versao=" + nota.versao,
			method: "POST",
			data: {
				acao: 'inserir_avaliacao',
				id: nota.id,
				nota: nota.nota,
				versao: nota.versao,
				texto: nota.texto
			},
			headers: {
				"Api-Token": this.token
			},
			responseType: "blob"
		}).then(response => {
			/*
			console.log({
                acao: 'inserir_avaliacao',
                id: nota.id,
                nota: nota.nota,
                versao: nota.versao
            }) */

			return response;
		}).catch(error => {
			return error.response;
			// this.redirectError(error.response.status);
		});
	};


	/**
	 * Nova Api com base em: 
	 * https://documenter.getpostman.com/view/10942599/TzCMe8mR#f9263893-7536-464f-a91e-709f53dcca37
	 */

	obterToken() {
		/**
		 * user:site
		 * pass:@atumComBatata
		 */


		var form = new FormData();
		form.append("strEmail", 'site');
		form.append("strSenha", '@atumComBatata');



		var config = {
			method: 'post',
			url: process.env.VUE_APP_ROOT_API + 'Services/Login/RealizarLogin',
			data: form
		};

		return axios(config).then(function(response) {
			/**
			 * Vamos temporáriamente setar o cookie com o token
			 * document.cookie = 'operacional='+response.data.token
			 */

			document.cookie = 'operacional=' + response.data.token

			return response.data.token
		}).catch(function(error) {
			console.log(error)
		})
	}

	ObterDadosSolicitante(userId, token) {

		var config = {
			method: 'get',
			url: process.env.VUE_APP_ROOT_API + 'Services/Consultoria/ConsultoriaIntegracao/ObterDadosSolicitante/' + userId + '?token=' + token
		}

		return axios(config).then(function(response) {
			/**
			 * a rota de obter dados não está retornando os dados do usuário ainda
			 * Irei retornar o objeto exemplo para poder popular o data
			 */
			// console.log(response);
			// response = {
			// 	data: {
			// 		"nome": "",
			// 		"telefone": "",
			// 		"cidade": "",
			// 		"uf": "",
			// 		"emails": []
			// 	}
			// }
			return response.data
		}).catch(function(error) {
			return error
		})
	}

	getCookie(chave) {
		var name = chave + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	listarAreas(token) {
		var urlAreas = process.env.VUE_APP_ROOT_API + 'Services/Agenda/Obrigacao/ListarAreas?token=' + token;
		var config = {
			method: 'GET',
			url: urlAreas
		};

		return axios(config)
			.then(function(response) {
				return response.data
			})
			.catch(function(error) {
				console.log(error);
			});
	}
	listarTemasPorIdArea(token, id) {
		var config = {
			method: 'get',
			url: process.env.VUE_APP_ROOT_API + 'Services/ConsultoriaEditar/ListarTemasPorIdArea/' + id + '?token=' + token,
			headers: {}
		};

		return axios(config)
			.then(function(response) {
				return response.data.filter((tema) => tema.blAtivo == 1)
			})
			.catch(function(error) {
				console.log(error);
			});
	}



	ListarMotivoRetorno(token) {
		var config = {
			method: 'get',
			url: process.env.VUE_APP_ROOT_API + 'Services/Consultoria/ConsultoriaIntegracao/ListarMotivoRetorno?token=' + token,
			headers: {}
		};

		axios(config)
			.then(function(response) {
				console.log(JSON.stringify(response.data));
				return response.data
			})
			.catch(function(error) {
				console.log(error);
			});
	}

	obterNaoLidaseAreas(idCLiente, token) {
		var config = {
			method: 'post',
			url: process.env.VUE_APP_ROOT_API + 'Services/ConsultoriaIntegracao/ObterNaoLidaseAreas?token=' + token,
			headers: {},
			data: data
		};

		axios(config)
			.then(function(response) {
				console.log(JSON.stringify(response.data));
				return response.data
			})
			.catch(function(error) {
				console.log(error);
			});
	}

	listarConsultas(form) {

		var config = {
			method: 'POST',
			url: process.env.VUE_APP_ROOT_API + 'Services/Agenda/ConsultoriaIntegracao/ListarConsultasCliente',
			headers: {},
			data: form
		}

		return axios(config)
			.then(function(response) {
				//console.log(JSON.stringify(response.data));

				return response.data
			})
			.catch(function(error) {
				console.log(error);
			});
	}

	listarConsulta(form) {
		var config = {
			method: 'POST',
			url: process.env.VUE_APP_ROOT_API + 'Services/Consultoria/ConsultoriaIntegracao/ListarConsulta',
			data: form
		};

		return axios(config)
			.then(function(response) {

				return response
			})
			.catch(function(error) {
				console.log(error);
			});
	}

	listarConsultasBusca(token) {
		var data = {
			idCliente: '$_SESSION["Cadastro_Usuario_ID"]',
			idArea: '$_GET["area"]',
			dtIni: '$_GET["dtIni"]',
			dtFim: '$_GET["dtFim"]',
			strAssunto: '$_GET["assunto"]',
			email: '$_GET["email"]'
		}

		var config = {
			method: 'post',
			url: process.env.VUE_APP_ROOT_API + 'Services/Agenda/ConsultoriaIntegracao/ListarConsultasBusca?token=' + token,
			headers: {},
			data: data
		};

		axios(config)
			.then(function(response) {
				console.log(JSON.stringify(response.data));
				return response.data
			})
			.catch(function(error) {
				console.log(error);
			});
	}

	listarDetalhesNovaConsulta(token) {
		var data = {
			idCliente$_SESSION: "['Cadastro_Usuario_ID']",
			idConsultoria$_GET: "['con']",
			tipo$_GET: "['tipCad']"
		}

		var config = {
			method: 'post',
			url: process.env.VUE_APP_ROOT_API + 'Services/Consultoria/ConsultoriaIntegracao/ListarDetalhesNovaConsulta?token=' + token,
			headers: {},
			data: data
		};

		axios(config)
			.then(function(response) {
				console.log(JSON.stringify(response.data));
				return response.data
			})
			.catch(function(error) {
				console.log(error);
			});
	}

	novaConsulta(token, formData) {
		/**
		 * Revisar o processo
		 * 
		 * data de referência
		 */

		var config = {
			method: 'post',
			url: process.env.VUE_APP_ROOT_API + 'Services/ConsultoriaIntegracao/NovaConsultaSite?token=' + token,
			data: formData,
			headers: {
				'content-type': 'multipart/form-data'
			}
		};

		return axios(config)
			.then(function(response) {

				return response
			})
			.catch(function(error) {
				return error
			});
	}

	novaPergunta(token, form) {
		/* 
		 * Data de referência
		 */



		var config = {
			method: 'post',
			url: process.env.VUE_APP_ROOT_API + 'Services/ConsultoriaIntegracao/NovaPerguntaSite',
			headers: {},
			data: form
		};



		return axios(config)
			.then(function(response) {
				
				return response
			})
			.catch(function(error) {
				return error
			});
	}

	avaliarPorEmail(token, data) {
		/**
		 * Data base
		 * data = {
		 * idCliente: "idCliente",
		 * idIteracao: "idIteracao",
		 * nota: "nota"
		 * }
		 */
		var config = {
			method: 'post',
			url: process.env.VUE_APP_ROOT_API + 'Services/ConsultoriaIntegracao/AvaliarporEmail?token=' + token,
			headers: {},
			data: data
		};

		axios(config)
			.then(function(response) {
				console.log(JSON.stringify(response.data));
				return response.data
			})
			.catch(function(error) {
				console.log(error);
			});
	}

	AvaliarMensagem(form, token) {

		var config = {
			method: 'post',
			url: process.env.VUE_APP_ROOT_API + 'Services/Consultoria/ConsultoriaIntegracao/AvaliarMensagem?token=' + token,
			headers: {},
			data: form
		};

		return axios(config)
			.then(function(response) {

				return response.data
			})
			.catch(function(error) {

			});
	}

	ListarConfigExpress(form) {
		var config = {
			method: 'post',
			url: process.env.VUE_APP_ROOT_API + 'Consultoria/ListarConfiguracaoConsultaExpress',
			headers: {},
			data: form
		};

		return axios(config)
			.then(function(response) {

				return response.data
			})
			.catch(function(error) {

			});
	}
}